/**
 * @file DeviceAddForm.tsx
 * @description Форма нового устройства склада (вынесена из `WmsSettingsPage`
 * в phase19.23 этап A).
 *
 * Виды и способы подключения берутся реестрами `DEVICE_KIND_LABEL` /
 * `DEVICE_TRANSPORT_LABEL` — новая запись в реестре появляется в форме сама,
 * без правки разметки.
 *
 * phase19.31 (зона «Склад»): заголовок без капса, поле `Input` кабинета,
 * размеры — из темы.
 */

import { useState } from "react";

import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { SelectField } from "../../ui/SelectField";
import {
  DEVICE_KIND_LABEL,
  DEVICE_TRANSPORT_LABEL,
  type WmsDeviceKind,
  type WmsDeviceTransport,
} from "../../../lib/api-wms";

interface Props {
  onSubmit: (input: {
    kind: WmsDeviceKind;
    transport: WmsDeviceTransport;
    name: string;
  }) => void;
  onCancel: () => void;
}

export function DeviceAddForm({ onSubmit, onCancel }: Props) {
  const [kind, setKind] = useState<WmsDeviceKind>("PRINTER_LABEL");
  const [transport, setTransport] = useState<WmsDeviceTransport>("NETWORK");
  const [name, setName] = useState("");

  return (
    <div className="flex max-w-[45rem] flex-col gap-3 rounded-xl bg-surface-lowest p-4 [box-shadow:inset_0_0_0_1px_var(--border)]">
      <h2 className="type-card-title text-on-surface">Новое устройство</h2>
      {/* Виды и транспорты — реестрами из api-wms: новая запись видна сразу. */}
      <SelectField
        value={kind}
        onChange={(next) => setKind(next as WmsDeviceKind)}
        options={Object.entries(DEVICE_KIND_LABEL).map(([value, label]) => ({
          value,
          label,
        }))}
        ariaLabel="Вид устройства"
      />
      <SelectField
        value={transport}
        onChange={(next) => setTransport(next as WmsDeviceTransport)}
        options={Object.entries(DEVICE_TRANSPORT_LABEL).map(([value, label]) => ({
          value,
          label,
        }))}
        ariaLabel="Подключение устройства"
      />
      <Input
        placeholder="Имя устройства (Zebra ZT230 на упаковке)"
        aria-label="Имя устройства"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <div className="flex gap-2">
        <Button
          onClick={() => onSubmit({ kind, transport, name: name.trim() })}
          disabled={!name.trim()}
        >
          Добавить
        </Button>
        <Button variant="outline" onClick={onCancel}>
          Отмена
        </Button>
      </div>
    </div>
  );
}
